module.exports = __webpack_public_path__ + "img/2plants.c762b69d.svg";